module.exports = __webpack_public_path__ + "img/client_gross_analyse.4a0752fe.png";